var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-container"},[_c('strong',[_vm._v(_vm._s(_vm.disabled_item))]),_c('ul',{staticClass:"scrollable-list"},_vm._l((_vm.ordens_servico),function(ordem,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(ordem)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }